import { getJSONCriteria } from 'modules/jsonRulesCriterias/businessCriteria';
import { FinanceProgramForm } from '../schema';

export function mapCriteriaFormValuesToCreateInput(formValue: FinanceProgramForm, accountId: string) {
  const programAvailableForLenders = formValue.program.first.details.lenders.map(({ value }) => value);

  return {
    accountId,
    notes: '',
    guidelines: '',
    financeProgramIdsToLink: [],
    name: formValue.program.first.details.displayName,
    lenderProfileIdsToLink: programAvailableForLenders,
    jsonCriteria: getJSONCriteria(formValue.program.first.criteria?.conditions),
  };
}
